var _ellipse, _ellipse2, _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeInactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 30,
    viewBox: "0 0 28 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 14,
    cy: 27.1644,
    rx: 13.5391,
    ry: 2.22795,
    fill: "url(#paint0_radial_1241_65041)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 13.9998,
    cy: 27.1644,
    rx: 5.48418,
    ry: 0.342761,
    fill: "url(#paint1_radial_1241_65041)",
    fillOpacity: 0.7
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 6.83124L5.60653 5.02869L6.98721 10.4364L2.5 13.3128V6.83124Z",
    fill: "#D8D8D8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9279 0.196167L16.766 1.80696L12.087 6.33253L7.71484 3.80128L13.9279 0.196167Z",
    fill: "#D8D8D8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5105 6.83102L17.9551 2.45886L18.1852 8.78698L25.5105 10.9731V6.83102Z",
    fill: "#D8D8D8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4732 20.4461V11.2416L19.0684 15.3453L21.0243 23.0157L25.4732 20.4461Z",
    fill: "#D8D8D8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.94531 16.9944L2.46094 15.4603V20.4845L8.13707 23.7444L7.94531 16.9944Z",
    fill: "#D8D8D8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8315 23.1307L13.9664 19.4105L9.0957 24.358L13.9664 27.196L20.8315 23.1307Z",
    fill: "#D8D8D8"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1241_65041",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14 27.1644) rotate(90) scale(2.22795 13.5391)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A2A2A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_1241_65041",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13.9998 27.1644) rotate(90) scale(0.342761 5.48418)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeInactive);
export default __webpack_public_path__ + "static/media/home-inactive.2049df842ab5225fd5544705fe7e4ee1.svg";
export { ForwardRef as ReactComponent };